<template>
  <Header />
  <RouterView />
  <Footer />
  <CookieConsent />
</template>

<script>
import Footer from "./components/Footer.vue";
import Header from "./components/Header.vue";
import CookieConsent from "./components/CookieConsent.vue";

export default {
  components: {
    Header,
    Footer,
    CookieConsent,
  },
};
</script>

<style src="./assets/tailwind.css" />

<style>
.container {
  width: 100%;
  max-width: 100% !important;
  box-sizing: border-box;
  margin-inline: auto;
  padding-right: 19.8vw;
  padding-left: 19.8vw;
}
@media (max-width: 1800px) {
  .container {
    padding-right: 14vw;
    padding-left: 14vw;
  }
}
@media (max-width: 1440px) {
  .container {
    padding-right: 10vw;
    padding-left: 10vw;
  }
}
@media (max-width: 1340px) {
  .container {
    padding-right: 5%;
    padding-left: 5%;
  }
}
</style>
